import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d13ba75a&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13ba75a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d13ba75a', component.options)
    } else {
      api.reload('d13ba75a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=d13ba75a&scoped=true&", function () {
      api.rerender('d13ba75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/tools/Index.vue"
export default component.exports